import { featureFlagsTracking } from "@/contexts/CdpProvider";
import { useClassified } from "@/contexts/classified";
import { useConfig } from "@/contexts/cdpConfig";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
// TODO !!
// @ts-ignore
export const useTrackingViewMedias = (pageTitle) => {
    var _a, _b, _c;
    const { av_distribution_type_global, av_client_type, av_items } = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : {};
    const av_client_id = (_c = av_items === null || av_items === void 0 ? void 0 : av_items[0]) === null || _c === void 0 ? void 0 : _c.client_id;
    const { env, trackingSite } = useConfig();
    const { language } = useLocale();
    return {
        av_pagetitle: pageTitle,
        av_category: "classified",
        av_distribution_type_global,
        av_ab_test_variant: featureFlagsTracking,
        av_environment: env,
        av_site: trackingSite,
        av_language: language,
        av_client_type,
        av_client_id,
    };
};
